import { useAppliedFilters } from './useAppliedFilters';
import { GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc.dfc.new';
import { GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY as GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY_PUBLIC } from '../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontPublicRpc.dfc.new';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
export function useAsyncFilterOptions() {
  const appliedFilters = useAppliedFilters();
  const asyncAppliedFilters = appliedFilters.filter(f => f.hasMoreOptions);
  return usePersonalizationQuery({
    app: GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY,
    public: GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY_PUBLIC,
    options: {
      variables: {
        filters: Object.fromEntries(asyncAppliedFilters.map(f => [f.field, f.values]))
      },
      skip: asyncAppliedFilters.length === 0
    }
  });
}